"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmountItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../../../ui");
var _utils = require("../../../../../../utils");
var _ticker = require("../../../../../ticker");
var _Item = require("./Item");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var NumberFormatColoring = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
var NumberWrapper = (0, _styledComponents.default)(_ui.H6)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-bottom: 0;\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiaryShade;
}, _utils.mediaQuery.greaterThan('sm')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-left: auto;\n    width: fit-content;\n  "]))));
var AmountItem = (0, _styledComponents.default)(function (_ref3) {
  var title = _ref3.title,
    ticker = _ref3.ticker,
    fiatTicker = _ref3.fiatTicker,
    amount = _ref3.amount,
    fiatTickerAmount = _ref3.fiatTickerAmount,
    rounding = _ref3.rounding,
    className = _ref3.className;
  return /*#__PURE__*/_react.default.createElement(_Item.Item, {
    title: title,
    className: className
  }, /*#__PURE__*/_react.default.createElement(NumberWrapper, null, /*#__PURE__*/_react.default.createElement(NumberFormatColoring, null, /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    rounding: rounding,
    value: amount,
    ticker: fiatTicker
  }), ' ', fiatTicker), ' = ', /*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: ticker
  }), /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    rounding: rounding,
    value: fiatTickerAmount,
    ticker: ticker
  })));
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])));
exports.AmountItem = AmountItem;